import { Image, Button } from 'react-bootstrap';
import DefaultAvatar from 'components/global/DefaultAvatar';
import { $user, $detail } from 'signals/global.signals';
import { useNavigate } from 'react-router-dom';
import { handleShowModal } from 'components/global/_helpers/global.helpers';

const PublicRoomProfile = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="d-flex mb-16 align-items-center">
        <Button
          className="bg-transparent border-0 p-0 me-16"
          onClick={() => navigate($user.value.id ? `/company/${$detail.value.orgId}` : '/login')}
        >
          <div
            className="d-flex align-items-center justify-content-center rounded-circle"
            style={{ height: '6rem', width: '6rem', overflow: 'hidden' }}
          >
            {$detail.value.logo
              ? <Image src={$detail.value.logo} className="w-100 h-100" style={{ objectFit: 'cover' }} />
              : <DefaultAvatar name={$detail.value.companyName} styleArr={$detail.value.logoColors} fontSize="2.5rem" />}
          </div>
        </Button>
        <div>
          <h4 className="fw-600 m-0">{$detail.value.companyName}</h4>
        </div>
      </div>
      <div
        className="pe-lg-40 mb-32 mb-lg-0 text-light"
        style={{
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {$detail.value.description || 'No description provided.'}
      </div>
      <div className="mt-24">
        {$user.value.userTypeId !== 1 && (
          !$user.value.id ? (
            <div className="d-flex flex-column">
              <div
                className="fw-600 text-start"
                onClick={() => navigate(`/login?redirect=/deal/${$detail.value.dealId}`)}
                role="button"
                tabIndex={0}
              >
                <u className="text-info">Login / Create Account to Save Deal</u>
              </div>
            </div>
          ) : (
            <div>
              {$detail.value.dealExistsInPipeline ? (
                <>
                  <div className="mb-16 border-top border-gray-700 pt-16">
                    This Deal exists in your Dealflow.
                  </div>
                  <Button
                    variant="dark"
                    onClick={() => navigate('/investor/dealflow')}
                    role="button"
                    tabIndex={0}
                    size="sm"
                    className="border-info text-info"
                  >
                    View My Dealflow
                  </Button>
                </>
              ) : (
                <Button
                  variant="dark"
                  className="fw-600 border-info text-info"
                  onClick={() => handleShowModal('add-to-pipeline')}
                  size="sm"
                >
                  Add to Pipeline
                </Button>
              )}
            </div>
          )
        )}
      </div>
    </>
  );
};

export default PublicRoomProfile;
